const { create } = require("zustand");

const useAlertStore = create((set) => ({
  showMessage: false,
  alertDetail: {
    title: null,
    heading: null,
    body: null,
    type: "warning",
    timeout: 8000
  },

  showAlert: async (item) => {
    try {
      set((state) => ({
        ...state,
        alertDetail: {
          ...state.alertDetail,
          ...item,
          timeout: item?.timeout !== undefined ? item.timeout : 8000
        },
        showMessage: true
      }));
    } catch (error) {
      console.error("Failed to update store data", error?.message);
    }
  },

  clearAlert: async () => {
    try {
      set((state) => ({
        ...state,
        showMessage: false,

        alertDetail: {
          title: null,
          heading: null,
          body: null,
          type: "warning",
          alertTimeOut: 8000
        }
      }));
    } catch (error) {
      console.error("Failed to reset store data", error?.message);
    }
  }
}));

export default useAlertStore;
